export default function ExternalLink({ href, children }) {

	return (
		<a href={href} className="text-[#f7f8f8] hover:underline" target="_blank" rel="noreferrer">{children}</a>
	)
}
